<template>
  <div class="notification-attachments">
    <BaseSubHeading
      v-for="(attachment, index) in attachments.slice(0, 3)"
      :key="index"
      size="small"
      weight="500"
      color="monochrome-07"
      class="notification-attachments__attachment"
    >
      <icon
        data="@icon/file.svg"
        :fill="true"
        width="var(--icon-24)"
        height="var(--icon-24)"
        :color="iconColor"
      />
      {{ attachment.name }}
    </BaseSubHeading>

    <BaseSubHeading
      v-if="attachmentsCount > 3"
      size="medium"
      weight="400"
      color="monochrome-05"
      darkColor="monochrome-04"
      class="notification-attachments__link"
    >
      and {{ attachmentsCount - 3 }} more
    </BaseSubHeading>
  </div>
</template>
<script lang="ts" setup>
import { computed, defineProps } from "vue"
import { useStore } from "vuex"

import BaseSubHeading from "@/components/Base/BaseSubHeading.vue"

import { NotificationAttachments } from "@/models"
import { Getters } from "@/store"

defineProps<{
  attachments: NotificationAttachments[]
  url: string
  attachmentsCount: number
}>()

const store = useStore()

const isDark = computed(() => store.getters[Getters.THEME_IS_DARK])
const iconColor = computed(() => (isDark.value ? "#AFB4C0" : "#81889B"))
</script>

<style lang="scss" scoped>
.notification-attachments {
  display: flex;
  flex-direction: column;
  margin-top: var(--step2);
  gap: var(--step1);

  &__attachment {
    display: inline-block;
    overflow: hidden;
    width: 100%;
    padding: var(--step1);
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .svg-icon {
    margin-right: var(--step2);
  }

  &__link {
    padding: var(--step1);
    margin-top: var(--step1);
  }
}
</style>
